var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinLine = function SvgLinkedinLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 9.797c.825-.844 1.9-1.395 3.15-1.395a4.95 4.95 0 0 1 4.95 4.95v6.75h-1.8v-6.75a3.15 3.15 0 1 0-6.3 0v6.75h-1.8V8.852H12zM5.7 7.052a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7m-.9 1.8h1.8v11.25H4.8z"
  })));
};
export default SvgLinkedinLine;